import { Link } from '@tanstack/react-router'
import { PanelsTopLeft } from 'lucide-react'

import { Button } from '@/components/ui/button'

import { cx } from '@/lib/cva-config'
import { Menu } from './menu'
import { SidebarToggle } from './sidebar-toggle'
import { useSidebar } from './use-sidebar'
import { useStore } from './use-store'

export function Sidebar() {
  const sidebar = useStore(useSidebar, (x) => x)

  if (!sidebar) return null
  const { isOpen, toggleOpen, getOpenState, setIsHover, settings } = sidebar
  const openState = getOpenState()

  return (
    <aside
      className={cx(
        'fixed left-0 top-0 z-20 h-screen -translate-x-full transition-[width] duration-300 ease-in-out lg:translate-x-0',
        !getOpenState() ? 'w-[90px]' : 'w-72',
        settings.disabled && 'hidden'
      )}
    >
      <SidebarToggle isOpen={isOpen} setIsOpen={toggleOpen} />
      <div
        onMouseEnter={() => setIsHover(true)}
        onMouseLeave={() => setIsHover(false)}
        className="relative flex h-full flex-col overflow-y-auto px-3 py-4 shadow-md dark:shadow-zinc-800"
      >
        <Button
          className={cx(
            'mb-1 transition-transform duration-300 ease-in-out',
            !openState ? 'translate-x-1' : 'translate-x-0'
          )}
          variant="link"
          asChild
        >
          <Link to="/dashboard" className="flex items-center gap-2">
            {openState ? (
              <img src="/brand-yes.png" alt="brand-yes" className="h-8" />
            ) : (
              <img
                src="/brand.png"
                alt="brand-yes"
                className="-ml-3 h-6 min-w-fit"
              />
            )}
          </Link>
        </Button>
        <Menu isOpen={getOpenState()} />
      </div>
    </aside>
  )
}
